import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import "firebase/messaging";
import "firebase/performance";
import "firebase/storage";
import "firebase/functions";
import "firebase/app-check";

import firebase from "firebase/app";

const {
  REACT_APP_API_KEY,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_DATABASE_URL,
  REACT_APP_PROJECT_ID,
  REACT_APP_STORAGE_BUCKET,
  REACT_APP_MESSAGING_SENDER_ID,
  REACT_APP_APP_ID,
  REACT_APP_MEASUREMENT_ID,
  REACT_APP_USE_EMULATORS,
  REACT_APP_LOCALE,
} = process.env;

let config = {
  apiKey: REACT_APP_API_KEY,
  authDomain: REACT_APP_AUTH_DOMAIN,
  databaseURL: REACT_APP_DATABASE_URL,
  projectId: REACT_APP_PROJECT_ID,
  storageBucket: REACT_APP_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
  appId: REACT_APP_APP_ID,
  measurementId: REACT_APP_MEASUREMENT_ID,
};

const useEmulators = REACT_APP_USE_EMULATORS === "true";
if (firebase.apps && !firebase.apps.length) {
  const databasePort = 8080;
  firebase.initializeApp(config);

  const appCheck = firebase.appCheck();
  appCheck.activate("6LdzEgscAAAAADh2LTdSw_IfM99aHhbcf3pXQWyl");

  if (useEmulators) {
    firebase.firestore().useEmulator("localhost", databasePort);
    firebase.auth().useEmulator("http://localhost:9099/");
    firebase.functions().useEmulator("localhost", 5001);

    const appCheck = firebase.appCheck();
    appCheck.activate("6LdzEgscAAAAADh2LTdSw_IfM99aHhbcf3pXQWyl");
  }
}
firebase.auth().languageCode = REACT_APP_LOCALE || "cs";

export const app = firebase.app();
export const auth = firebase.auth();
export const db = firebase.firestore();
export const functions = app.functions("europe-west1");
if (useEmulators) functions.useEmulator("localhost", 5001);

export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();
export const storage = firebase.storage();
export const { TaskEvent } = firebase.storage;

export type DocumentReference = firebase.firestore.DocumentReference;
export type QuerySnapshot = firebase.firestore.QuerySnapshot;
export type Query = firebase.firestore.Query;
export type DocumentSnapshot = firebase.firestore.DocumentSnapshot;
export type DocumentData = firebase.firestore.DocumentData;
export type FieldValue = firebase.firestore.FieldValue;
export type FirebaseStorageError = firebase.storage.FirebaseStorageError;
export type OrderByDirection = firebase.firestore.OrderByDirection;
export type Timestamp = firebase.firestore.Timestamp;
export type User = firebase.User;
export type UserCredential = firebase.auth.UserCredential;
export type WhereFilterOp = firebase.firestore.WhereFilterOp;

export default firebase;
